export const topLevelDomain = "amazonaws.com";
